/**
 * 資産化 / 費用化の内訳を示すドーナツ。
 *
 * ライブラリを持ち込まず SVG の stroke-dasharray で描く。
 * 表現するのは 2 区分の比率だけなので、これで足りる。
 */
export interface DonutProps {
  /** 0-1。資産化の割合 */
  ratio: number;
  size?: number;
  label?: string;
}

export function Donut({ ratio, size = 148, label }: DonutProps) {
  const radius = 52;
  const circumference = 2 * Math.PI * radius;
  const filled = circumference * Math.min(1, Math.max(0, ratio));

  return (
    <svg width={size} height={size} viewBox="0 0 148 148" role="img" aria-label={label}>
      <circle
        cx="74"
        cy="74"
        r={radius}
        fill="none"
        className="stroke-line-bold"
        strokeWidth="20"
      />
      <circle
        cx="74"
        cy="74"
        r={radius}
        fill="none"
        className="stroke-brand-500"
        strokeWidth="20"
        strokeDasharray={`${filled} ${circumference}`}
        transform="rotate(-90 74 74)"
      />
      <text
        x="74"
        y="80"
        textAnchor="middle"
        className="fill-ink font-mono"
        style={{ fontSize: '22px' }}
      >
        {label ?? `${Math.round(ratio * 1000) / 10}%`}
      </text>
    </svg>
  );
}
